module.exports = __webpack_public_path__ + "img/h1.c6f59ebd.png";